import { render, staticRenderFns } from "./EModalHistoricoDePagamentos.vue?vue&type=template&id=45d93171"
import script from "./EModalHistoricoDePagamentos.vue?vue&type=script&lang=js"
export * from "./EModalHistoricoDePagamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports